import app from '../../scripts/app';
import template from './bs-center-preview.jade';

app.directive('cianAfBsCenterPreview', () => {
  return {
    template,
    scope: {},
    bindToController: {
      item: '=',
      view: '@',
    },
    controller: [
      function () {
        const photoObj = this.item.photos && (this.item.photos.find(item => item.isDefault) || this.item.photos[0]);
        if (photoObj && photoObj.listingMiniUrl) {
          this.photo = photoObj.listingMiniUrl;
        } else {
          this.photo = null;
        }
      },
    ],
    controllerAs: 'bsCenterPreviewCtrl',
  };
});
